import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadsCapValuationRequestSuccess, getLeadsCapValuationRequestFailure } from '../../actions/cap_actions/get_cap_valuation.actions';
import { GET_LEADS_CAP_VALUATION_REQUEST } from '../../constants/cap.constants';
import { message_success, message_error } from '../../../../../../components/Message';
import { getCapValuation } from '../../../requests/cap_requests/get_cap_valuation_request';

function* getCapValuationRequest({
    derivative_id, full_year, year, year_code, mileage, _id,
}) {
    // Call CAP lambda which saves CAP valuation results to Bike_Lead model
    const { result, options, error } = yield call(getCapValuation, derivative_id, full_year, year, year_code, mileage, _id);

    if (result) {
        yield put(getLeadsCapValuationRequestSuccess({
            retail: options.retail,
            clean: options.clean,
            avg: options.average,
            date: new Date().toISOString(),
        }));
        message_success('CAP Valuation added successfully!');
    } else if (error) {
        yield put(getLeadsCapValuationRequestFailure(error));
        message_error(error.message);
    } else {
        yield put(getLeadsCapValuationRequestFailure());
        message_error('CAP price cannot be found');
    }
}

export default function* getCapValuationSaga() {
    yield takeEvery(GET_LEADS_CAP_VALUATION_REQUEST, getCapValuationRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/cap.sagas/get_cap_valuation.saga.js